<template>
  <v-flex>
    <div class="table-items-container" id="tableItemsContainer"
         :class="{'table-height-full' : _itemsTableContent.length <= pagination.rowsPerPage }">
      <v-data-table
        ref="datatable"
        :headers="headers"
        :items="_itemsTableContent"
        :pagination.sync="pagination"
        :hide-actions="true"
        :loading="_tableLoading"
        style="width: 100%;"
        item-key="nomenklatura_id"
        class="elevation-0"
      >
        <template v-slot:headerCell="props">
          <span>{{ props.header.value === 'tsena' && _currentDocument.name === 'schet' ? 'Цена с НДС' : props.header.text }}</span>
          <div v-if="props.header.enumeration" class="grey--text">({{ props.header.enumeration }})</div>
        </template>
        <template v-slot:items="props">
          <tr :class="props.item.trClass" @mouseup="selectRow($event, props.item.nomenklatura_id)"
              @mouseenter="hoverRow($event, props.item.nomenklatura_id, true)"
              @mouseleave="hoverRow($event, props.item.nomenklatura_id, false)"
              v-if="/*props.item.tsena > 700 && */(
                    !props.item.trClass ||
                    (props.item.trClass === 'rezerved' && _itemsDisplaySettings('showRezerv')) ||
                    (props.item.trClass === 'ontheway' && _itemsDisplaySettings('showTranzit')) ||
                    (props.item.trClass === 'priemka' && _itemsDisplaySettings('showPriemka'))
                    ) && (_itemsDisplaySettings('showRecommendedOnly') ? props.item.recommended === '1' : true)
"
          >
            <td class="text-xs-right">{{ props.item.nomenklatura_id }}</td>
            <td class="">{{ props.item.name }}</td>
            <td class="text-xs-right">{{ props.item.warranty }}</td>
            <template v-if="props.item.disable">
              <td colspan="3">{{ props.item.disable_message}}</td>
            </template>
            <template v-else>
              <td class="text-xs-right" v-html="props.item.tsena + (!parseInt(props.item.has_nds_rate) && _currentDocument.name === 'schet' ? '<br><span class=\'grey--text caption\'>без НДС</span>' : '')"></td>
              <td class="text-xs-right">{{ props.item.quantity }}</td>
              <td class="text-xs-right" style="text-align: right">
                <template v-if="!!parseInt(props.item.st)">
                  <v-chip
                    label
                    color="primary"
                    text-color="white"
                    v-if="props.item.nomenklatura_id === hoverRowId || true"
                    @click="handleQuantity(props.item)"
                  >
                    <v-icon small :left="!!props.item.kolichestvo" color="white">mdi-settings</v-icon>
                    {{props.item.kolichestvo}}
                  </v-chip>
                  <template v-else>{{props.item.kolichestvo}}</template>
                </template>
                <input
                  v-else
                  @change="handleQuantity(props.item)"
                  v-model.number="props.item.kolichestvo"
                  @focus="$event.target.select()"
                  type="number"
                  min="0"
                  v-numericOnly
                  pattern="\d*"
                  class="table-qty">
              </td>
            </template>
          </tr>
        </template>
        <template slot="no-data">
          <empty-table
            :emptyText="'Выберите папку'"
          />
        </template>
      </v-data-table>
    </div>
    <div class="text-xs-center pt-2 table-pagination" v-if="_itemsTableContent.length > pagination.rowsPerPage">
      <v-pagination v-model="pagination.page" :length="pages" @input="goToTop"></v-pagination>
    </div>
  </v-flex>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { mapMultiRowFields, mapFields } from 'vuex-map-fields'
import { numericOnly } from '@/directives/numericOnly'
import numberFormat from '@/filters/numberFormat'
import emptyTable from '@/components/helpers/EmptyTable'

export default {
  name: 'CatalogItemsTable',
  directives: {
    numericOnly
  },
  filters: {
    numberFormat
  },
  components: {
    emptyTable
  },
  data () {
    return {
      selectedRowId: null,
      hoverRowId: null,
      pagination: {
        sortBy: 'name',
        rowsPerPage: 50
      },
      isLoading: false,
      headers: [
        {
          text: '№',
          align: 'right',
          width: '100px',
          value: 'nomenklatura_id'
        },
        {
          text: 'Наименование',
          value: 'name'
        },
        {
          text: 'Гарантия',
          enumeration: 'мес.',
          align: 'right',
          width: '40px',
          value: 'warranty'
        },
        {
          text: 'Цена',
          align: 'right',
          width: '100px',
          value: 'tsena'
        },
        {
          text: 'К-во',
          align: 'right',
          width: '100px',
          value: 'quantity'
        },
        {
          text: '',
          align: 'right',
          width: '100px',
          value: 'kolichestvo'
        }
      ]
    }
  },
  computed: {
    ...mapGetters('catalog', {
      _itemsDisplaySettings: 'itemsDisplaySettings',
      _currentDocument: 'currentDocument',
      _itemsTableContentData: 'itemsTableContentData',
      _tableLoading: 'tableLoading',
      _error: 'error'
    }),
    ...mapMultiRowFields('catalog', {
      _itemsTableContent: 'itemsTableContent'
    }),
    ...mapFields('catalog', {
      _showError: 'showError'
    }),
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) {
        return 0
      }
      let contentLength = 0
      this._itemsTableContent.forEach((record) => {
        if ((
          !record.trClass ||
          (record.trClass === 'rezerved' && this._itemsDisplaySettings('showRezerv')) ||
          (record.trClass === 'ontheway' && this._itemsDisplaySettings('showTranzit')) ||
          (record.trClass === 'priemka' && this._itemsDisplaySettings('showPriemka'))
        ) && (this._itemsDisplaySettings('showRecommendedOnly') ? record.recommended === '1' : true)) {
          contentLength++
        }
      })
      return Math.ceil(contentLength / this.pagination.rowsPerPage)
    }
  },
  methods: {
    ...mapActions('catalog', {
      _addRecordToDocument: 'addRecordToDocument',
      _updateRecordToDocument: 'updateRecordToDocument',
      _beforeChangeQuantity: 'beforeChangeQuantity',
      _setError: 'setError'
    }),
    goToTop () {
      this.$vuetify.goTo(0, {
        duration: 0,
        offset: 0,
        easing: 'easeInOutCubic',
        container: '#tableItemsContainer'
      })
    },
    selectRow (e, itemId) {
      let text = ''
      if (window.getSelection) {
        text = window.getSelection().toString()
      }
      if (!text) {
        if (this.selectedRowId !== itemId) {
          this.selectedRowId = itemId
          !e.target.closest('tr').querySelector('input') || e.target.closest('tr').querySelector('input').focus()
        }
      }
    },
    hoverRow (e, itemId, isHovered) {
      if (isHovered) {
        if (this.hoverRowId !== itemId) {
          this.hoverRowId = itemId
        }
      } else {
        this.hoverRowId = null
      }
    },
    handleQuantity (item) {
      this._showError = false
      this._beforeChangeQuantity(item)
      if (this._error) {
        this._showError = true
        item.kolichestvo = ''
        return false
      } else {
        this._setError(false)
      }

      if (parseInt(item.st)) {
        let record = this._currentDocument.records.find((obj) => obj.nomenklatura_id === item.nomenklatura_id) || {}
        this.$emit('openOptionsDialog', { ...this._itemsTableContentData[this._itemsTableContent.indexOf(item)], ...record })
      } else {
        this.setQuantity(item)
      }
    },
    setQuantity (item) {
      let record = this._currentDocument.records.find((obj) => obj.nomenklatura_id === item.nomenklatura_id)
      if (record) {
        this._updateRecordToDocument({
          nomenklatura_id: item.nomenklatura_id,
          kolichestvo: item.kolichestvo,
          name: item.name,
          warranty: item.warranty,
          has_nds_rate: item.has_nds_rate,
          tsena: item.tsena,
          st: item.st
        })
      } else {
        this._addRecordToDocument({
          nomenklatura_id: item.nomenklatura_id,
          kolichestvo: item.kolichestvo,
          name: item.name,
          warranty: item.warranty,
          has_nds_rate: item.has_nds_rate,
          tsena: item.tsena,
          st: item.st
        })
      }
    }
  }
}
</script>

<style lang="stylus">
  .table-qty {
    border: 1px solid rgba(0, 0, 0, 0.12);
    width: 50px;
    margin: 0;
    text-align: right;
    padding: 5px;
    outline: none;
  }

  .rezerved {
    color: red;
  }

  .ontheway {
    color: blue;
  }

  .priemka {
    color: purple;
  }

  .table-items-container {
    background white
    height: calc(100% - 51px);
    //height: calc(100% - 51px);
    width: 100%;
    overflow: auto;
    flex-grow 0.5
    display: flex;
    flex-wrap nowrap
    justify-content flex-start
    @media screen and (max-width: 599px) {
      width: 100%
      height: auto
    }
    @media screen and (min-width: 600px) and (max-width: 959px) {
      width: 100%
      height: auto
    }
    @media screen and (min-width: 960px) and (max-width: 1263px) {
      width: calc(100% - 300px)
    }
  }

  .table-height-full {
    height: 100%;
  }

  .table-pagination {
    border-top: 1px solid rgb(204, 204, 204);
  }

</style>
